<template>
  <div id="tags-container" class="mt-5">
    <div id="tags-header">
      <h3>{{ $t("coworking-info.tags.title") }}</h3>
      <p v-html="$t('coworking-info.tags.features.title')"></p>
    </div>
    <div id="tags-selection">
      <div id="features">
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.features.fast-wifi") }}
          <input
            v-model="info.selectedFeatures"
            type="checkbox"
            value="fast_wifi"
            :disabled="
              !isEdit ||
                (info.selectedFeatures.length >= 2 &&
                  info.selectedFeatures.indexOf('fast_wifi') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.features.bar") }}
          <input
            v-model="info.selectedFeatures"
            type="checkbox"
            value="bar"
            :disabled="
              !isEdit ||
                (info.selectedFeatures.length >= 2 &&
                  info.selectedFeatures.indexOf('bar') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.features.second-monitor") }}
          <input
            v-model="info.selectedFeatures"
            type="checkbox"
            value="second_monitor"
            :disabled="
              !isEdit ||
                (info.selectedFeatures.length >= 2 &&
                  info.selectedFeatures.indexOf('second_monitor') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.unlimited-coffee") }}
          <input
            v-model="info.selectedFeatures"
            type="checkbox"
            value="unlimited_coffee_tea"
            :disabled="
              !isEdit ||
                (info.selectedFeatures.length >= 2 &&
                  info.selectedFeatures.indexOf('unlimited_coffee_tea') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.features.private-rooms") }}
          <input
            v-model="info.selectedFeatures"
            type="checkbox"
            value="private_rooms"
            :disabled="
              !isEdit ||
                (info.selectedFeatures.length >= 2 &&
                  info.selectedFeatures.indexOf('private_rooms') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.features.spot-outlets") }}
          <input
            v-model="info.selectedFeatures"
            type="checkbox"
            value="spot_outlets"
            :disabled="
              !isEdit ||
                (info.selectedFeatures.length >= 2 &&
                  info.selectedFeatures.indexOf('spot_outlets') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
      </div>
      <div id="style">
        <div class="mt-4 mb-2">
          <p v-html="$t('coworking-info.tags.style.title')"></p>
        </div>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.style.industrial") }}
          <input
            v-model="info.selectedStyle"
            type="checkbox"
            value="industrial"
            :disabled="
              !isEdit ||
                (info.selectedStyle.length == 1 &&
                  info.selectedStyle.indexOf('industrial') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.style.lounge") }}
          <input
            v-model="info.selectedStyle"
            type="checkbox"
            value="lounge"
            :disabled="
              !isEdit ||
                (info.selectedStyle.length == 1 &&
                  info.selectedStyle.indexOf('lounge') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.style.hipster") }}
          <input
            v-model="info.selectedStyle"
            type="checkbox"
            value="hipster"
            :disabled="
              !isEdit ||
                (info.selectedStyle.length == 1 &&
                  info.selectedStyle.indexOf('hipster') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.style.new-chic") }}
          <input
            v-model="info.selectedStyle"
            type="checkbox"
            value="new_chic"
            :disabled="
              !isEdit ||
                (info.selectedStyle.length == 1 &&
                  info.selectedStyle.indexOf('new_chic') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.style.casual") }}
          <input
            v-model="info.selectedStyle"
            type="checkbox"
            value="casual"
            :disabled="
              !isEdit ||
                (info.selectedStyle.length == 1 &&
                  info.selectedStyle.indexOf('casual') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.style.bar") }}
          <input
            v-model="info.selectedStyle"
            type="checkbox"
            value="bar"
            :disabled="
              !isEdit ||
                (info.selectedStyle.length == 1 &&
                  info.selectedStyle.indexOf('bar') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
      </div>
      <div id="social-aspect">
        <div class="mt-4 mb-2">
          <p v-html="$t('coworking-info.tags.socials.title')"></p>
        </div>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.socials.videogames") }}
          <input
            v-model="info.selectedAspect"
            type="checkbox"
            value="video_games"
            :disabled="
              !isEdit ||
                (info.selectedAspect.length == 1 &&
                  info.selectedAspect.indexOf('video_games') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.socials.tabletop-games") }}
          <input
            v-model="info.selectedAspect"
            type="checkbox"
            value="tabletop_games"
            :disabled="
              !isEdit ||
                (info.selectedAspect.length == 1 &&
                  info.selectedAspect.indexOf('tabletop_games') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.socials.cool-atmosphere") }}
          <input
            v-model="info.selectedAspect"
            type="checkbox"
            value="cool_atmosphere"
            :disabled="
              !isEdit ||
                (info.selectedAspect.length == 1 &&
                  info.selectedAspect.indexOf('cool_atmosphere') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.socials.dog-friendly") }}
          <input
            v-model="info.selectedAspect"
            type="checkbox"
            value="dog_friendly"
            :disabled="
              !isEdit ||
                (info.selectedAspect.length == 1 &&
                  info.selectedAspect.indexOf('dog_friendly') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.socials.lgbtq") }}
          <input
            v-model="info.selectedAspect"
            type="checkbox"
            value="lgbtq"
            :disabled="
              !isEdit ||
                (info.selectedAspect.length == 1 &&
                  info.selectedAspect.indexOf('lgbtq') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
        <label class="control control-checkbox">
          {{ $t("coworking-info.tags.socials.female-only") }}
          <input
            v-model="info.selectedAspect"
            type="checkbox"
            value="female_only"
            :disabled="
              !isEdit ||
                (info.selectedAspect.length == 1 &&
                  info.selectedAspect.indexOf('female_only') === -1)
            "
          />
          <div class="control_indicator"></div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info", "isEdit"]
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";

#tags-header {
  h3 {
    font-family: $inter;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #767676;
  }

  p {
    margin-top: 10px;
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #767676;
  }
}

#style {
  p {
    margin-top: 10px;
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #767676;
  }
}

#social-aspect {
  p {
    margin-top: 10px;
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #767676;
  }
}

.control {
  display: block;
  position: relative;
  padding-left: 2rem;
  margin-bottom: 0.5rem;
  padding-top: 0.2rem;
  cursor: pointer;
  font-family: $worksans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #000000;

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;

    &:checked ~ .control_indicator:after {
      display: block;
    }

    &:hover ~ .control_indicator {
      border: none;
    }

    &:disabled ~ .control_indicator {
      background: #111112;
      opacity: 0.6;
      pointer-events: none;
    }

    &:checked ~ .control_indicator {
      background: #04b900;
      opacity: 0.6;
      pointer-events: none;
    }
  }
}

.control_indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 22px;
  width: 22px;
  background: #c4c4c4;
  box-sizing: border-box;
  border-radius: 3px;

  &:after {
    box-sizing: unset;
    content: "";
    position: absolute;
    display: none;
  }
}

.control-checkbox {
  .control_indicator:after {
    left: 8px;
    top: 5px;
    width: 3px;
    height: 7px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  input:disabled ~ .control_indicator:after {
    border-color: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/info/components/Tags.vue